// extracted by mini-css-extract-plugin
export var badge = "_v8-4";
export var selected = "_v8-1";
export var selectedOverlay = "_v8-5";
export var thumbnailButton = "_v8-0";
export var thumbnailFallback = "_v8-3";
export var thumbnailImage = "_v8-2";